export default __webpack_public_path__ + "static/media/arrow.1f0d5ff0.svg";